import React, { useState, useEffect } from "react";
import { Button, notification, Result, Input, Typography } from "antd";
import moment from "moment";
import { connect } from "react-redux";
import agent from "../../../agent";
import Logo from "../../../assets/img/payment_logo.png";
import {
  CLIENTTOKEN,
  CLIENTBOOKING,
  ORDERLIST,
  PAYMENTS,
  BOOKDETAILS,
  DELETEBOOKING,
  COUPON,
  STRIPECHARGES,
  UPDATEBOOKING,
} from "../../../core-units/constants/actionTypes";
import StripeCheckout from "react-stripe-checkout";
import { GlobalVariable } from "../../../core-units/config/generalConfig";
import "../ev-home-page.css";
import _ from "lodash";
const { Text, Link } = Typography;

const StepPayment = (props) => {
  const [evTotal, setEvTotal] = useState(0);
  const [orderEvId, setOrderEvId] = useState(0);
  const [evCoupon, setEvCoupon] = useState("");
  const [evLoading, setEvLoading] = useState(false);
  const [evBookingData, setEvBookingData] = useState({});

  useEffect(() => {
    async function apiCall() {
      setEvTotal(_.multiply(localStorage.getItem("evTotal"), 100));
      setOrderEvId(localStorage.getItem("ev_order_id"));
    }
    apiCall();
  }, []);

  /**creating booking */
  const bookingClass = async () => {
    const addEvField = _.get(props, "addfield.data", []);
    const additional_ev_fields = {};
    const retriveEvValues = localStorage.hasOwnProperty("allEvValues")
      ? localStorage.getItem("allEvValues")
      : {};
    const evTimeStramp = localStorage.getItem("evTime");
    const allEvValues = !_.isEmpty(retriveEvValues)
      ? JSON.parse(retriveEvValues)
      : {};
    const clientData = {
      name: allEvValues.name,
      email: allEvValues.email,
      phone: `+61${allEvValues.phone}`,
    };
    
    // Validate all required values are present with detailed error messages
    const requiredFields = {
      "Your Name": allEvValues.name,
      "Your Email": allEvValues.email,
      "Your Phone": allEvValues.phone,
      "Seller Name": allEvValues.SellerName,
      "Seller Phone Number": allEvValues.SellerPhonenumber,
      "Car Location": localStorage.getItem("selectedEvValuelocation"),
      "Car Model": allEvValues.CarModel,
      "Odometer Reading": allEvValues.OdometerReading,
      "Car ID Number (Rego/VIN/Chassis)": allEvValues.CarIdNumber,
      "Rego/VIN/Chassis Type": localStorage.getItem("evRego"),
    };

    // Collect all missing fields
    const missingFields = [];
    for (const [fieldName, value] of Object.entries(requiredFields)) {
      if (!value || value === "") {
        missingFields.push(fieldName);
      }
    }

    // If there are missing fields, show detailed error
    if (missingFields.length > 0) {
      const errorMessage = missingFields.join(", ");
      notification.error({
        message: "Required Fields Missing",
        description: `Please fill the following fields: ${errorMessage}`,
        duration: 0,
      });
      return;
    }

    if (!_.isEmpty(addEvField)) {      
      return _.map(addEvField, function (val, key) {
        switch (val.name) {
          case "174f93dea26a3e68edd5863971f1a776":
            additional_ev_fields[val.name] = allEvValues.SellerName || "";
            break;
          case "1e03f7a8574a6acea8d9871c3fb65b25":
            additional_ev_fields[val.name] = allEvValues.SellerPhonenumber || "";
            break;
          case "2d42cf2bb70e82898ba9ffc46dba74f2":
            additional_ev_fields[val.name] = localStorage.getItem(
              "selectedEvValuelocation"
            ) || "";
            break;
          case "9f785f73333f13a44dbd5cc9df0060f4":
            additional_ev_fields[val.name] = allEvValues.CarModel || "";
            break;
          case "ac59cc4cfbdefb7805668ea679018e02":
            additional_ev_fields[val.name] = allEvValues.OdometerReading || "";
            break;
          case "661e7ff7914016277b3e4de4c62fb285":
            additional_ev_fields[val.name] = allEvValues.CarIdNumber || "";
            break;
          case "a25f4d5f4cba4c7428d27430d7dca0d6":
            additional_ev_fields[val.name] = localStorage.getItem("evRego") || "";
            break;
          case "a6bf0d4d47602038ef0bbb2fd3ff6f22":
            additional_ev_fields[val.name] = localStorage.getItem("evPrice") || "";
            break;
          case "36820785829f0404de8fb18d886350a7":
            additional_ev_fields[val.name] = allEvValues.notes || "";
            break;
          case "73de0266822ac41e149412761cf1b731":
            additional_ev_fields[val.name] = allEvValues.year || "";
        }
        if (
          Object.keys(additional_ev_fields).length ===
          _.get(props, "addfield.metadata.items_count")
        ) {
          let addEvField = { ...additional_ev_fields, handle_invoice: true };
          createBooking(addEvField, clientData);
        }
      });
    }
  };
  /**NEW BOOKING API CALLS */
  const createBooking = (addEvField, clientData) => {
    setEvTotal(evTotal);
    const retrieveEvService = localStorage.hasOwnProperty("evService")
      ? localStorage.getItem("evService")
      : {};
    const time = localStorage.getItem("evTime");
    const date = moment(localStorage.getItem("evDate")).format("YYYY-MM-DD");
    const service = !_.isEmpty(retrieveEvService)
      ? JSON.parse(retrieveEvService)
      : {};
    const retrieveEvProduct = localStorage.hasOwnProperty("evProduct")
      ? localStorage.getItem("evProduct")
      : {};
    const product = !_.isEmpty(retrieveEvProduct)
      ? JSON.parse(retrieveEvProduct)
      : {};
    const products = _.map(product, function (val, key) {
      return { id: val.id, qty: 1 };
    });
    let additional_ev_fields = { ...addEvField, products: products };
    // The API expects the additional fields under the key `additional_fields`
    let requestBody = {
      start_datetime: moment(date + " " + time).format("YYYY-MM-DD HH:mm:ss"),
      date,
      time,
      provider_id: localStorage.getItem("selectedEvProviderId"),
      service_id: service.id,
      products: products,
      client_id: localStorage.getItem("client_id"),
      accept_payment: "true",
      payment_processor: "delay",
      additional_fields: additional_ev_fields,
      clientData,
    };
    setEvLoading(true);
    setEvBookingData(requestBody);
    props.token(requestBody, (value) => {
      props.clientBook(requestBody, (valu) => {
        if (_.get(valu, "result")) {
          setEvLoading(false);
          localStorage.setItem("bookId", valu.result.bookings[0].id);
          setOrderEvId(valu.result.invoice.id);
          localStorage.setItem("order_id", valu.result.invoice.id);
        } else if (
          _.isEqual(valu.error.message, "Selected time slot is not available")
        ) {
          props.setCurrent(1);
          props.setIsSlotAvailable(false);
          localStorage.removeItem("evDate");
          localStorage.removeItem("evTime");
        } else if (
          _.isEqual(valu.error.message, "Selected unit id is not available") ||
          _.isEqual(valu.error.message, "Selected time slot is not available")
        ) {
          const ids = _.chain(_.get(props, "provider.data")).map("id").value();
          var i = 0;
          if (i <= requestBody.provider_id) {
            i++;
            if (i >= requestBody.provider_id) {
              requestBody = { ...requestBody, provider_id: ids[i] };
              props.clientBook(requestBody, (valu) => {
                if (_.get(valu, "result")) {
                  setEvLoading(false);
                  localStorage.setItem("evBookId", valu.result.bookings[0].id);
                  setOrderEvId(valu.result.invoice.id);
                  localStorage.setItem("ev_order_id", valu.result.invoice.id);
                } else {
                  i++;
                  requestBody = { ...requestBody, provider_id: ids[i] };
                  props.clientBook(requestBody, (valu) => {
                    if (_.get(valu, "result")) {
                      setEvLoading(false);
                      localStorage.setItem(
                        "evBookId",
                        valu.result.bookings[0].id
                      );
                      setOrderEvId(valu.result.invoice.id);
                      localStorage.setItem("ev_order_id", valu.result.invoice.id);
                    } else {
                      setEvLoading(false);
                      notification.error({
                        message: "Error",
                        description: "Booking error try another time",
                      });
                    }
                  });
                }
              });
            }
          }
        } else {
          setEvLoading(false);
          notification.error({
            message: "Error",
            description: _.capitalize(
              _.get(valu, "error.message", "Booking error")
            ),
          });
        }
      });
    });
  };

  /**Promo function */
  const promoHandling = () => {
    let requestBody = { code: evCoupon, id: orderEvId };
    props.coupons(requestBody, (value) => {
      notification.success({
        message: "Success",
        description: "Applied successfully ",
      });
      localStorage.setItem("evCouponData", value);
      if (!_.isEmpty(value.promotion_instances)) {
        _.map(value.promotion_instances, function (val, key) {
          setEvTotal(val.amount);
        });
      }
    });
  };

  /**payment call */
  const paymentHandling = (token) => {
    const retrievevalues = localStorage.getItem("allEvValues") || {};
    const allEvValues = JSON.parse(retrievevalues);

    const clientData = {
      Clientname: allEvValues.name,
      Clientemail: allEvValues.email,
      Clientphone: allEvValues.phone,
    };

    props.stripeCharge(
      {
        token: token.id,
        amount: evTotal,
        clientData,
      },
      (values, error) => {
        let requestBody = {
          payment_processor: "stripe",
          id: orderEvId,
        };

        let urlParams = { id: localStorage.getItem("ev_order_id") };

        props.payment(requestBody, urlParams, () => {
          localStorage.clear();
          notification.success({
            message: "Success",
            description: "Paid successfully",
          });
        });
      }
    );
  };
  const render = () => {
    const ButtonAfter = <Button onClick={promoHandling}>Apply</Button>;
    const retrieveService = localStorage.hasOwnProperty("evService")
      ? localStorage.getItem("evService")
      : {};
    const time = localStorage.getItem("evTime");
    const date = moment(localStorage.getItem("evDate")).format("YYYY-MM-DD");
    const service = !_.isEmpty(retrieveService)
      ? JSON.parse(retrieveService)
      : {};
    const retrievevalues = localStorage.hasOwnProperty("allEvValues")
      ? localStorage.getItem("allEvValues")
      : {};
    const allEvValues = !_.isEmpty(retrievevalues)
      ? JSON.parse(retrievevalues)
      : {};
    const retrieveProduct = localStorage.hasOwnProperty("evProduct")
      ? localStorage.getItem("evProduct")
      : "[]";
    let product = [];
    try {
      product = JSON.parse(retrieveProduct);
      if (!Array.isArray(product)) {
        product = [];
      }
    } catch (e) {
      product = [];
    }
    if (_.get(props, "stripeCharges") === true) {
      return (
        <div className="EvPaymentSuccessBlock">
          <Result status="error" title="Payment error" />,
        </div>
      );
    } else if (_.get(props, "paymentDetails.payment_received")) {
      return (
        <div className="EvPaymentSuccessBlock">
          <Result status="success" title="Successfully Paid" />,
        </div>
      );
    } else if (_.isEqual(_.get(props, "paymentDetails.code"), 400)) {
      props.delete_bookings({ id: localStorage.getItem("evBookId") });
      return (
        <div className="EvPaymentSuccessBlock">
          <Result
            status="error"
            title={_.get(props, "paymentDetails.message")}
          />
          ,
        </div>
      );
    } else if (_.get(props, "clientbooking.result.bookings")) {
      return (
        <div className="EvPaymentStepsContainer">
          <div className="EvStepsFormCardContainer">
            <div className="row justify-content-center">
              <div className="col-12 col-md-12 col-lg-6">
                {(() => {
                  if (_.get(props, "couponlist.status")) {
                    return (
                      <div style={{ textAlign: "center" }}>
                        <div className="EvInspectionStepTitle pb-3">
                          {_.get(service, "name")}{" "}
                          <b>$ {_.get(service, "price")}</b>
                          {_.map(product, function (val, key) {
                            return (
                              <React.Fragment key={key}>
                                {" "}
                                + <br />
                                {_.get(val, "name")}{" "}
                                <b>$ {_.get(val, "price")}</b>
                              </React.Fragment>
                            );
                          })}
                        </div>
                        <div className="EvCouponCodeTotal mb-4">
                          <div className="row justify-content-center">
                            <div className="col-auto">
                              <div className="EvCouponCodeTotalSection box-shadow-none">
                                <span className="mr-1">Total</span>
                                <span className=" mr-1">
                                  <Text delete>
                                    $ {_.get(props, "couponlist.deposit")}
                                  </Text>
                                </span>
                                <span className="EvCouponCodeTotalAmount">
                                  <Text>
                                    $ {_.get(props, "couponlist.amount")}
                                  </Text>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })()}
                <div className="EvStepsFormCard">
                  <div className="row">
                    <div className="col-12 col-md-12">
                      <div className="row">
                        {(() => {
                          if (_.get(props, "couponlist.status")) {
                            return (
                              <div className="PricingAddOnTitle">
                                Coupon Applied
                              </div>
                            );
                          } else {
                            return (
                              <div className="PricingAddOnTitle">
                                Coupon Code
                              </div>
                            );
                          }
                        })()}
                        <div className="EvCouponCodeInputSection">
                          <div className="row justify-content-center">
                            <div className="col-12 col-md-10 col-lg-10">
                              <Input
                                placeholder="1245DSERF12"
                                onChange={(e) => setEvCoupon(e.target.value)}
                                addonAfter={ButtonAfter}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-12">
                      <div className="EvStripe-container">
                        <StripeCheckout
                          className="ant-btn PayNowBtn"
                          image={Logo}
                          description="Secure payments"
                          locale="auto"
                          name="SafeBuy"
                          amount={evTotal}
                          currency="AUD"
                          token={paymentHandling}
                          stripeKey={GlobalVariable.STRIPE_PUBLISHABLE_KEY}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="EvPaymentStepsContainer">
          <div className="EvStepsFormCardContainer">
            <div className="row justify-content-center">
              <div className="col-12 col-md-12 col-lg-6">
                <div className="EvStepsFormCard">
                  <div className="row">
                    <div className="col-12 col-md-12">
                      <div className="row">
                        <div className="form-group col-12 col-lg-6">
                          <div className="form-label">Services</div>
                          <div className="form-value">
                            {_.get(service, "name")}{" "}
                            <b> $ {_.get(service, "price")}</b>
                          </div>
                        </div>
                        <div className="form-group col-12 col-lg-6">
                          <div className="form-label">Add-ons</div>

                          {_.map(product, function (val, key) {
                            const name = _.get(val, "product.name", val.name);
                            const price = _.get(val, "product.price", val.price);
                            return (
                              <div className="form-value" key={key}>
                                {" "}
                                {name}{" "}
                                <b>$ {price}</b>{" "}
                              </div>
                            );
                          })}
                        </div>
                        <div className="form-group col-12 col-lg-6">
                          <div className="form-label">Booking Date</div>
                          <div className="form-value">{date}</div>
                        </div>
                        <div className="form-group col-12 col-lg-6">
                          <div className="form-label">Booking Time</div>
                          <div className="form-value">{time}</div>
                        </div>
                        <div className="form-group col-12 col-lg-6">
                          <div className="form-label">Car Location</div>
                          <div className="form-value">
                            {localStorage.getItem("selectedEvValuelocation")}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-12">
                      <div className="steps-action confirm-booking">
                        <Button
                          type="primary"
                          onClick={bookingClass}
                          loading={evLoading}
                        >
                          Confirm Booking
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };
  return render();
};

const mapStateToProps = (state) => ({
  addfield: state.booking.additionalfields,
  booking: state.booking.newbookinglist,
  orderlist: state.booking.orderlist,
  paymentDetails: state.booking.paymentDetails,
  couponlist: state.services.couponlist,
  clientbooking: state.clientBooking.clientbookinglist,
  provider: state.services.providerList,
  stripeCharges: state.booking.stripeCharges,
});

const mapDispatchToProps = (dispatch) => ({
  token: (params, callback) =>
    dispatch({
      type: CLIENTTOKEN,
      payload: agent.ClientBooking.token(params),
      callback: callback,
    }),
  clientBook: (params, callback) =>
    dispatch({
      type: CLIENTBOOKING,
      payload: agent.ClientBooking.booking(params),
      callback: callback,
    }),
  order_list: (params, callback) =>
    dispatch({
      type: ORDERLIST,
      payload: agent.Bookings.order_list(params),
      callback: callback,
    }),
  payment: (params, urlParams, callback) =>
    dispatch({
      type: PAYMENTS,
      payload: agent.Bookings.payment(params, urlParams),
      callback: callback,
    }),
  booking_details: (params, callback) =>
    dispatch({
      type: BOOKDETAILS,
      payload: agent.Bookings.bookDetails(params),
      callback: callback,
    }),
  delete_bookings: (params, callback) =>
    dispatch({
      type: DELETEBOOKING,
      payload: agent.Bookings.delete(params),
      callback: callback,
    }),
  coupons: (params, callback) =>
    dispatch({
      type: COUPON,
      payload: agent.Services.promo_code(params),
      callback: callback,
    }),
  stripeCharge: (params, callback) =>
    dispatch({
      type: STRIPECHARGES,
      payload: agent.Bookings.stripe_charges(params),
      callback: callback,
    }),
  update_booking: (params, callback) =>
    dispatch({
      type: UPDATEBOOKING,
      payload: agent.Bookings.update_booking(params),
      callback: callback,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(StepPayment);
